/**
 * A component to hold breadcrumbs
 */
export const ActBreadcrumbToolbar: ng.IComponentOptions = {
  templateUrl: 'app/angularJS/components/breadcrumb-toolbar/act-breadcrumb-toolbar.html',
  controller: 'BreadcrumbToolbarController',
  controllerAs: 'vm'
};